import { useEnterEvent } from "../../context/EnterEvent";

const TcConditions = () => {
  const { agreeRef, termsError, setTermChecked, setTermsError } =
    useEnterEvent();

  const handleTermsCheck = (e) => {
    setTermChecked(e.target.checked);
    if (e.target.checked) {
      setTermsError(false);
    }
  };

  return (
    <div className="card shadow-xss w-100 border-0 p-4 mb-3">
      <div className="card-body align-items-center p-0">
        <p className="text-current m-0">
          <strong>Step 5 of 6</strong>
        </p>

        <div className="agreement">
          <div className="agreement-title">
            <i className="fa-sharp fa-solid fa-file font-xxl text-current" />
            <h4 className="mt-2">ICN Membership Acknowledgement</h4>
          </div>
          <p className="text-left">
            In joining as an ICN Premium Member, I acknowledge and agree as
            follows:
          </p>
          <ol className="text-left">
            <li>
              <span className="text">
                To compete in an ICN contest, I must have been drug-free for a
                minimum of five continuous years before the contest.
              </span>
            </li>
            <li>
              <span className="text">
                I agree to be drug tested at any time and any number of times. A
                refusal or failure to provide a sample will be treated as an
                anti-doping rule violation and may carry the same sanctions as a
                positive test.
              </span>
            </li>
            <li>
              <span className="text">
                ICN and its relevant national and international federations have
                jurisdiction to administer drug testing and impose sanctions
                under ICN rules.
              </span>
            </li>
            <li ref={agreeRef}>
              <span className="text">
                Submitting an online entry is an application to compete. Under
                the ICN Eligibility Rule, ICN reserves the right to refuse an
                entry application at any time before the athlete competes.
              </span>
            </li>
            <li>
              <span className="text">
                I acknowledge that all eligibility, drug-testing, disciplinary
                and sanction decisions made by ICN under its rules are final and
                binding. To the fullest extent permitted by law, I agree not to
                bring any claim, arbitration, lawsuit or other proceeding
                relating to such decisions against ICN, its national or
                international federations, officials, promoters or
                representatives in any court or tribunal.
              </span>
            </li>
            <li>
              <span className="text">
                I confirm that I have read and understood the terms and
                conditions of this Acknowledgement.
              </span>
            </li>
          </ol>
          <div
            className={`agreement-checkbox ${termsError ? "terms-error" : ""}`}
          >
            <input
              type="checkbox"
              className="mr-1"
              onChange={handleTermsCheck}
              id="conditions"
            />
            <label htmlFor="conditions">
              {" "}
              I agree to the above
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TcConditions;
